<template>
  <van-popup :show="show" @update:show="$emit('update:show', $event)" :close-on-click-overlay="false"
    class="confirm-dialog" round>
    <div class="confirm-modal">
      <div class="confirm-title h-[40px] flex relative">
        <div class="w-full text-line-1-#004A36">
          {{ title || t('deposito.title') }}
        </div>
        <div @click="handleClose" class="w-[28px] h-[28px] absolute right-[5px] top-2/5 transform -translate-y-1/2">
          <Button type="close" class="!w-[28px] !h-[28px]" />
        </div>
      </div>
      <div class="px-[7px]">
        <div class="confirm-tip bg-[rgba(2,71,59,.65)] rounded-[5px] h-[107px] flex items-center justify-center">
          {{ message || t('deposito.redirectMessage') }}
        </div>
      </div>

      <div class="confirm-btns">
        <Button type="default" class="w-[126px] h-[43px] text-line-1.5-#084500" @click="handleConfirm">
          {{ t('confirm') }}
        </Button>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { Button } from '@/components/Button'
const { t } = useI18n()

interface Props {
  show: boolean
  message?: string
  title?: string
}

interface Emits {
  (e: 'update:show', value: boolean): void
  (e: 'confirm'): void
}

const props = withDefaults(defineProps<Props>(), {
  message: ''
})

const emit = defineEmits<Emits>()

const handleClose = () => {
  emit('update:show', false)
}

const handleConfirm = () => {
  emit('update:show', false)
  emit('confirm')
}
</script>

<style lang="scss" scoped>
.confirm-dialog {
  background: transparent;
  width: 100vw;
  display: flex;
  justify-content: center;
}

.confirm-modal {
  background: getPath('home/logoutPopBg.png') no-repeat;
  background-size: 100% calc(100% + 2px);
  border-radius: 10px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.18);
  padding: 5px;
  width: 90%;
  max-width: 333px;
  height: 234px;
  text-align: center;
}

.confirm-title {
  font-size: 21px;
  color: #FFFC11;
  font-weight: bolder;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-tip {
  color: #95DBCA;
  font-size: 13px;
  margin-bottom: 15px;
}

.confirm-btns {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  padding: 0 30px 0 30px;
}
</style>
